import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { AuthContextProvider } from './store/AuthContext.js';
import { runStartupCleanup } from './utils/localStorageCleanup.js';

// Clean up old localStorage keys on app startup
runStartupCleanup();

ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
